{
  "id": "norse",
  "name": {
    "pt-BR": "Nórdicos",
    "en": "Norse"
  },
  "icon": "ui/pantheon-norse",
  "workers": ["gatherer", "dwarf"],
  "townCenter": "town-center",
  "start": {
    "resources": {
      "food": 200,
      "wood": 150,
      "gold": 100,
      "favor": 0
    },
    "units": {
      "gatherer": 3,
      "berserk": 1
    },
    "buildings": {
      "town-center": 1,
      "ox-cart": 1,
      "sentry-tower": 4
    },
    "popCap": 15
  },
  "favor": {
    "type": "combat",
    "damagePerFavor": 80,
    "decayFrom": 100,
    "decayTo": 300,
    "defaultPerMinute": 0,
    "meta": {
      "source": "Game files 19.17020 (major_gods.xml bountyresourceearning)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "1 favor per 80 damage (bountydamagegoal 80) by human soldiers, heroes and buildings (reward 1.0); ships and favor-generating myth units 0.5 (1 per 160); Gatherers/Dwarves 4.0 (1 per 20). Odin: Hersir, Jarl, Godi, Raiding Cavalry 1.25 (1 per 64). Target multipliers: Huntable x0.5, Herdable x5, Building x0.1, shooting buildings x0.5, walls excluded. Gain falls from 100 to 300 total favor earned down to x0.5 (bountyreductionstrength 0.5). Hersir/Godi also trickle 0.6/min each (unit trickle). No favor cap in the files."
    }
  },
  "gods": ["odin", "thor", "loki"],
  "ageUps": [
    {
      "pantheon": "norse",
      "to": "classical",
      "cost": {
        "food": 400
      },
      "time": 60,
      "at": "town-center",
      "requiresAnyOf": [["temple"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ClassicalAge<Minor> techs: 400 food, 60 s, prereq one AbstractTemple. Researched at the Town Center or a Village Center. Each spawns the minor god's myth unit at a Temple."
      }
    },
    {
      "pantheon": "norse",
      "to": "heroic",
      "cost": {
        "food": 800,
        "gold": 500
      },
      "time": 75,
      "at": "town-center",
      "requiresAnyOf": [["armory"], ["dwarven-armory"], ["market"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "HeroicAge<Minor> techs: 800 food + 500 gold, 75 s, OrPrereqs: an Armory, Dwarven Armory or Market (HeroicAgeNjord: Armory or Market only; Njord is not a Thor minor)."
      }
    },
    {
      "pantheon": "norse",
      "to": "mythic",
      "cost": {
        "food": 1200,
        "gold": 1200
      },
      "time": 120,
      "at": "town-center",
      "requiresAnyOf": [["hill-fort"]],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "MythicAge<Minor> techs: 1200 food + 1200 gold, 120 s, prereq one AbstractFortress (Hill Fort)."
      }
    }
  ],
  "units": [
    {
      "id": "gatherer",
      "name": {
        "pt-BR": "Coletor",
        "en": "Gatherer"
      },
      "icon": "units/norse-gatherer",
      "pantheon": "norse",
      "tags": ["worker", "human"],
      "cost": {
        "food": 50
      },
      "pop": 1,
      "trainTime": 17,
      "trainedAt": ["town-center", "village-center"],
      "age": "archaic",
      "worker": {
        "gatherRates": {
          "hunt": 54,
          "herd": 48.6,
          "berries": 37.8,
          "farm": 37.8,
          "wood": 54,
          "gold": 46.2
        },
        "canBuild": true,
        "buildRate": 1,
        "needsDropsite": true,
        "builds": ["house", "farm", "ox-cart"]
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "VillagerNorse. Gather per second: wood 0.9, gold 0.77, hunt 0.9, herd 0.81, berries and farm 0.63. Build protoaction only lists Farm, House and OxCartBuilding (rate 1.0); every other building needs Norse infantry or heroes. Transform to Berserk (VillagerNorseToBerserk, instant): 30 food + 20 gold (Loki -50%); not modelled. Shares the 100 villager build limit with Dwarves."
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Gatherers and Dwarves can only build House, Farm and Ox Cart; Norse infantry and heroes build the rest."
        },
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml VillagerNorseToBerserk)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "Enabled for every Norse god by ArchaicAgeNorse; instant (0 research points); Loki -50%."
        }
      },
      "promotion": {
        "to": "berserk",
        "cost": {
          "food": 30,
          "gold": 20
        },
        "time": 0
      }
    },
    {
      "id": "dwarf",
      "name": {
        "pt-BR": "Anão",
        "en": "Dwarf"
      },
      "icon": "units/norse-dwarf",
      "pantheon": "norse",
      "tags": ["worker", "human"],
      "cost": {
        "gold": 60
      },
      "pop": 1,
      "trainTime": 17,
      "trainedAt": ["town-center", "village-center"],
      "age": "archaic",
      "worker": {
        "gatherRates": {
          "hunt": 42,
          "herd": 37.8,
          "berries": 29.4,
          "farm": 29.4,
          "wood": 42,
          "gold": 58.8
        },
        "canBuild": true,
        "buildRate": 1,
        "needsDropsite": true,
        "builds": ["house", "farm", "ox-cart"]
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "VillagerDwarf. Gather per second: gold 0.98, wood 0.7, hunt 0.7, herd 0.63, berries and farm 0.49. Builds only Farm, House and OxCartBuilding (rate 1.0). Thor: gold cost -10 (Absolute) and food/wood x1.25 BasePercent (thor.json). Transform to Berserk: 10 food + 30 gold. A negligible AutoGather Favor 0.00001/s is ignored."
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Gatherers and Dwarves can only build House, Farm and Ox Cart; Norse infantry and heroes build the rest."
        },
        "promotion": {
          "source": "Game files 19.17020 (techtree.xml VillagerDwarfToBerserk)",
          "checkedAt": "2026-10-29",
          "confidence": "high",
          "note": "Enabled for every Norse god by ArchaicAgeNorse; instant (0 research points); Loki -50%."
        }
      },
      "promotion": {
        "to": "berserk",
        "cost": {
          "food": 10,
          "gold": 30
        },
        "time": 0
      }
    },
    {
      "id": "berserk",
      "name": {
        "pt-BR": "Berserker",
        "en": "Berserk"
      },
      "icon": "units/norse-berserk",
      "pantheon": "norse",
      "tags": ["infantry", "human", "scout"],
      "cost": {
        "food": 50,
        "gold": 30
      },
      "pop": 2,
      "trainTime": 9,
      "trainedAt": ["town-center", "longhouse"],
      "age": "archaic",
      "worker": {
        "gatherRates": {},
        "canBuild": true,
        "buildRate": 1,
        "needsDropsite": false
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Trained at the Town Center and Village Center (Archaic) and the Longhouse (Classical). Build protoaction: Building 1.0, so it builds every Norse building except Farm and Ox Cart (not in its build list). One Berserk is a start unit."
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Norse infantry/hero Build protoaction rate Building 1.0 (same as the base builder). Gatherers/Dwarves only build Farm, House and Ox Cart (rate 1.0)."
        }
      },
      "plural": {
        "pt-BR": "Berserkers"
      }
    },
    {
      "id": "hersir",
      "name": {
        "pt-BR": "Hersir (Herói)",
        "en": "Hersir (Hero)"
      },
      "icon": "units/norse-hersir",
      "pantheon": "norse",
      "tags": ["hero", "infantry", "human"],
      "cost": {
        "food": 80,
        "gold": 40
      },
      "pop": 3,
      "trainTime": 16,
      "trainedAt": ["temple", "great-hall"],
      "age": "archaic",
      "worker": {
        "gatherRates": {},
        "canBuild": true,
        "buildRate": 1,
        "needsDropsite": false
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Official name 'Hersir (Hero)'. Trained at the Temple (Archaic) and the Great Hall. Builds (Building 1.0). AutoGather Favor 0.01/s = 0.6/min while alive; Hammer of Thunder x1.5 BasePercent. Combat favor via the pantheon rule (Odin x1.25)."
      },
      "fieldMeta": {
        "trickle": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Hersir protoaction AutoGather rate Favor 0.01/s (persistent) = 0.6/min while alive. Hammer of Thunder: x1.5 BasePercent (0.9/min)."
        },
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Norse infantry/hero Build protoaction rate Building 1.0 (same as the base builder). Gatherers/Dwarves only build Farm, House and Ox Cart (rate 1.0)."
        }
      },
      "trickle": {
        "favor": 0.6
      },
      "plural": {
        "pt-BR": "Hersires (Heróis)"
      }
    },
    {
      "id": "godi",
      "name": {
        "pt-BR": "Godi (Herói)",
        "en": "Godi (Hero)"
      },
      "icon": "units/norse-godi",
      "pantheon": "norse",
      "tags": ["hero", "archer", "human"],
      "cost": {
        "wood": 80,
        "gold": 40
      },
      "pop": 3,
      "trainTime": 16,
      "trainedAt": ["great-hall"],
      "age": "heroic",
      "worker": {
        "gatherRates": {},
        "canBuild": true,
        "buildRate": 1,
        "needsDropsite": false
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Official name 'Godi (Hero)'. Trained at the Great Hall. Enabled by HeroicAgeNorse, or in Classical by Freyja's Sessrumnir (Enable Godi). AutoGather Favor 0.01/s = 0.6/min. Builds (Building 1.0)."
      },
      "fieldMeta": {
        "trickle": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Godi protoaction AutoGather rate Favor 0.01/s (persistent) = 0.6/min while alive."
        },
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Norse infantry/hero Build protoaction rate Building 1.0 (same as the base builder). Gatherers/Dwarves only build Farm, House and Ox Cart (rate 1.0)."
        },
        "age": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "HeroicAgeNorse enables the Godi; Freyja's Sessrumnir also has 'Enable Godi', so with Freyja it is trainable in Classical (not expressible)."
        }
      },
      "trickle": {
        "favor": 0.6
      },
      "plural": {
        "pt-BR": "Godis (Heróis)"
      }
    },
    {
      "id": "hirdman",
      "name": {
        "pt-BR": "Hird",
        "en": "Hirdman"
      },
      "icon": "units/norse-hirdman",
      "pantheon": "norse",
      "tags": ["infantry", "human"],
      "cost": {
        "food": 40,
        "gold": 45
      },
      "pop": 2,
      "trainTime": 14,
      "trainedAt": ["longhouse"],
      "age": "classical",
      "worker": {
        "gatherRates": {},
        "canBuild": true,
        "buildRate": 1,
        "needsDropsite": false
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Longhouse, enabled by ClassicalAgeNorse. Builds (Building 1.0)."
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Norse infantry/hero Build protoaction rate Building 1.0 (same as the base builder). Gatherers/Dwarves only build Farm, House and Ox Cart (rate 1.0)."
        }
      }
    },
    {
      "id": "throwing-axeman",
      "name": {
        "pt-BR": "Lançador de Machados",
        "en": "Throwing Axeman"
      },
      "icon": "units/norse-throwing-axeman",
      "pantheon": "norse",
      "tags": ["infantry", "archer", "human"],
      "cost": {
        "wood": 50,
        "gold": 40
      },
      "pop": 2,
      "trainTime": 15,
      "trainedAt": ["longhouse"],
      "age": "classical",
      "worker": {
        "gatherRates": {},
        "canBuild": true,
        "buildRate": 1,
        "needsDropsite": false
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Longhouse, enabled by ClassicalAgeNorse. Builds (Building 1.0)."
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Norse infantry/hero Build protoaction rate Building 1.0 (same as the base builder). Gatherers/Dwarves only build Farm, House and Ox Cart (rate 1.0)."
        }
      }
    },
    {
      "id": "huskarl",
      "name": {
        "pt-BR": "Huscarl",
        "en": "Huskarl"
      },
      "icon": "units/norse-huskarl",
      "pantheon": "norse",
      "tags": ["infantry", "human"],
      "cost": {
        "wood": 75,
        "gold": 40
      },
      "pop": 2,
      "trainTime": 6.5,
      "trainedAt": ["hill-fort"],
      "age": "heroic",
      "worker": {
        "gatherRates": {},
        "canBuild": true,
        "buildRate": 1,
        "needsDropsite": false
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hill Fort, enabled by HeroicAgeNorse. Builds (Building 1.0)."
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Norse infantry/hero Build protoaction rate Building 1.0 (same as the base builder). Gatherers/Dwarves only build Farm, House and Ox Cart (rate 1.0)."
        }
      }
    },
    {
      "id": "raiding-cavalry",
      "name": {
        "pt-BR": "Cavalaria Incursora",
        "en": "Raiding Cavalry"
      },
      "icon": "units/norse-raiding-cavalry",
      "pantheon": "norse",
      "tags": ["cavalry", "human"],
      "cost": {
        "food": 40,
        "gold": 50
      },
      "pop": 2,
      "trainTime": 10,
      "trainedAt": ["great-hall"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Great Hall, enabled by ClassicalAgeNorse. Cannot build."
      },
      "plural": {
        "pt-BR": "Cavalarias Incursoras"
      }
    },
    {
      "id": "jarl",
      "name": {
        "pt-BR": "Jarl",
        "en": "Jarl"
      },
      "icon": "units/norse-jarl",
      "pantheon": "norse",
      "tags": ["cavalry", "human"],
      "cost": {
        "food": 50,
        "gold": 80
      },
      "pop": 3,
      "trainTime": 14.5,
      "trainedAt": ["great-hall"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Great Hall, enabled by HeroicAgeNorse."
      }
    },
    {
      "id": "portable-ram",
      "name": {
        "pt-BR": "Aríete Portátil",
        "en": "Portable Ram"
      },
      "icon": "units/norse-portable-ram",
      "pantheon": "norse",
      "tags": ["siege"],
      "cost": {
        "wood": 125,
        "gold": 125
      },
      "pop": 3,
      "trainTime": 13,
      "trainedAt": ["hill-fort"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hill Fort, enabled by HeroicAgeNorse. Dwarven Auger: train time x0.75."
      },
      "plural": {
        "pt-BR": "Aríetes Portáteis"
      }
    },
    {
      "id": "ballista",
      "name": {
        "pt-BR": "Balista",
        "en": "Ballista"
      },
      "icon": "units/norse-ballista",
      "pantheon": "norse",
      "tags": ["siege"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "pop": 3,
      "trainTime": 17,
      "trainedAt": ["hill-fort"],
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hill Fort, enabled by MythicAgeNorse."
      }
    },
    {
      "id": "fishing-ship",
      "name": {
        "pt-BR": "Navio Pesqueiro",
        "en": "Fishing Ship"
      },
      "icon": "units/norse-fishing-ship",
      "pantheon": "norse",
      "tags": ["ship", "worker"],
      "cost": {
        "wood": 50
      },
      "pop": 1,
      "trainTime": 18,
      "trainedAt": ["dock"],
      "age": "archaic",
      "worker": {
        "gatherRates": {
          "fish": 33
        },
        "needsDropsite": true
      },
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Gather FishResource 0.55/s = 33/min. Build limit 50. Drops food at the Dock."
      },
      "fieldMeta": {
        "worker": {
          "source": "Game files 19.17020 (proto.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Gather FishResource 0.55/s = 33/min."
        }
      },
      "plural": {
        "pt-BR": "Navios Pesqueiros"
      }
    },
    {
      "id": "transport-ship",
      "name": {
        "pt-BR": "Navio de Transporte",
        "en": "Transport Ship"
      },
      "icon": "units/norse-transport-ship",
      "pantheon": "norse",
      "tags": ["ship"],
      "cost": {
        "wood": 110
      },
      "pop": 1,
      "trainTime": 19,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled by ClassicalAgeNorse. Carries 25."
      }
    },
    {
      "id": "longboat",
      "name": {
        "pt-BR": "Dracar",
        "en": "Longboat"
      },
      "icon": "units/norse-longboat",
      "pantheon": "norse",
      "tags": ["ship"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Arrow ship, enabled by ClassicalAgeNorse."
      }
    },
    {
      "id": "dreki",
      "name": {
        "pt-BR": "Dreki",
        "en": "Dreki"
      },
      "icon": "units/norse-dreki",
      "pantheon": "norse",
      "tags": ["ship"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Close-combat ship, enabled by ClassicalAgeNorse."
      }
    },
    {
      "id": "dragon-ship",
      "name": {
        "pt-BR": "Barco Dragão",
        "en": "Dragon Ship"
      },
      "icon": "units/norse-dragon-ship",
      "pantheon": "norse",
      "tags": ["ship", "siege"],
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "pop": 3,
      "trainTime": 16.5,
      "trainedAt": ["dock"],
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Siege ship, enabled by ClassicalAgeNorse."
      }
    },
    {
      "id": "ox-caravan",
      "name": {
        "pt-BR": "Caravana de Boi",
        "en": "Ox Caravan"
      },
      "icon": "units/norse-ox-caravan",
      "pantheon": "norse",
      "tags": ["caravan"],
      "cost": {
        "food": 100,
        "wood": 25
      },
      "pop": 1,
      "trainTime": 18,
      "trainedAt": ["market"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "CaravanNorse. Market, enabled by HeroicAgeNorse. Build limit 60."
      }
    },
    {
      "id": "valkyrie",
      "name": {
        "pt-BR": "Valquíria",
        "en": "Valkyrie"
      },
      "icon": "units/norse-valkyrie",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 200,
        "favor": 18
      },
      "pop": 3,
      "trainTime": 17,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["freyja"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temple. Enabled by ClassicalAgeFreyja, which also spawns one at a Temple."
      }
    },
    {
      "id": "einheri",
      "name": {
        "pt-BR": "Einheri",
        "en": "Einheri"
      },
      "icon": "units/norse-einheri",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 150,
        "favor": 15
      },
      "pop": 2,
      "trainTime": 17,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["heimdall"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temple. Enabled by ClassicalAgeHeimdall, which also spawns one at a Temple."
      }
    },
    {
      "id": "troll",
      "name": {
        "pt-BR": "Troll",
        "en": "Troll"
      },
      "icon": "units/norse-troll",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 160,
        "favor": 15
      },
      "pop": 2,
      "trainTime": 15,
      "trainedAt": ["temple"],
      "age": "classical",
      "requires": ["forseti"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temple. Enabled by ClassicalAgeForseti, which also spawns one at a Temple."
      }
    },
    {
      "id": "battle-boar",
      "name": {
        "pt-BR": "Javali de Batalha",
        "en": "Battle Boar"
      },
      "icon": "units/norse-battle-boar",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 250,
        "favor": 27
      },
      "pop": 3,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["bragi"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temple. Enabled by HeroicAgeBragi, which also spawns one at a Temple."
      }
    },
    {
      "id": "frost-giant",
      "name": {
        "pt-BR": "Gigante de Gelo",
        "en": "Frost Giant"
      },
      "icon": "units/norse-frost-giant",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 200,
        "favor": 22
      },
      "pop": 4,
      "trainTime": 20,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["skadi", "hel"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temple. Enabled by HeroicAgeSkadi (which spawns one) and by MythicAgeHel (no free one). Minor-god requires are any-of: skadi or hel."
      }
    },
    {
      "id": "mountain-giant",
      "name": {
        "pt-BR": "Gigante de Montanha",
        "en": "Mountain Giant"
      },
      "icon": "units/norse-mountain-giant",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 250,
        "favor": 25
      },
      "pop": 4,
      "trainTime": 17,
      "trainedAt": ["temple"],
      "age": "heroic",
      "requires": ["njord", "hel"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temple. Enabled by HeroicAgeNjord (which spawns one) and by MythicAgeHel (no free one). Minor-god requires are any-of: njord or hel."
      }
    },
    {
      "id": "fire-giant",
      "name": {
        "pt-BR": "Gigante de Fogo",
        "en": "Fire Giant"
      },
      "icon": "units/norse-fire-giant",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 300,
        "favor": 28
      },
      "pop": 4,
      "trainTime": 24,
      "trainedAt": ["temple"],
      "age": "mythic",
      "requires": ["baldr", "hel"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temple. Enabled by MythicAgeBaldr and MythicAgeHel; both spawn one at a Temple. Minor-god requires are any-of: baldr or hel."
      }
    },
    {
      "id": "fenris-wolf-brood",
      "name": {
        "pt-BR": "Ninhada de Lobo de Fenris",
        "en": "Fenris Wolf Brood"
      },
      "icon": "units/norse-fenris-wolf-brood",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 175,
        "favor": 15
      },
      "pop": 2,
      "trainTime": 12,
      "trainedAt": ["temple"],
      "age": "mythic",
      "requires": ["tyr"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Temple. Enabled by MythicAgeTyr, which also spawns one at a Temple."
      }
    },
    {
      "id": "kraken",
      "name": {
        "pt-BR": "Kraken",
        "en": "Kraken"
      },
      "icon": "units/norse-kraken",
      "pantheon": "norse",
      "tags": ["myth", "ship"],
      "cost": {
        "food": 300,
        "favor": 20
      },
      "pop": 4,
      "trainTime": 10,
      "trainedAt": ["dock"],
      "age": "heroic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Dock. Enabled for every Norse god by HeroicAgeNorse, which also creates one free Kraken at a Dock (CreateUnit generator=Dock). Not modelled as a free unit: it needs a Dock."
      }
    },
    {
      "id": "jormun-elver",
      "name": {
        "pt-BR": "Jormun Elver",
        "en": "Jormun Elver"
      },
      "icon": "units/norse-jormun-elver",
      "pantheon": "norse",
      "tags": ["myth", "ship"],
      "cost": {
        "food": 200,
        "favor": 15
      },
      "pop": 4,
      "trainTime": 10,
      "trainedAt": ["dock"],
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Dock. Enabled for every Norse god by MythicAgeNorse, which also creates one free Jormun Elver at a Dock (CreateUnit generator=Dock). Not modelled as a free unit: it needs a Dock."
      }
    }
  ],
  "buildings": [
    {
      "id": "town-center",
      "name": {
        "pt-BR": "Centro Urbano",
        "en": "Town Center"
      },
      "icon": "buildings/norse-town-center",
      "pantheon": "norse",
      "cost": {
        "wood": 350,
        "gold": 350
      },
      "buildTime": 150,
      "popCap": 15,
      "age": "classical",
      "trains": ["gatherer", "dwarf", "berserk"],
      "researches": ["masons", "architects", "fortified-town-center", "rigsthula"],
      "dropsiteFor": ["hunt", "herd", "berries", "farm", "wood", "gold"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "15 population (populationcapaddition). Build limit 1 in Archaic, removed by ClassicalAgeGeneral (BuildLimit -1). Dropsite for food, wood, gold. Built by Norse infantry/heroes (rate 1.0)."
      },
      "plural": {
        "pt-BR": "Centros Urbanos"
      }
    },
    {
      "id": "village-center",
      "name": {
        "pt-BR": "Centro de Aldeia",
        "en": "Village Center"
      },
      "icon": "buildings/norse-village-center",
      "pantheon": "norse",
      "cost": {
        "wood": 350,
        "gold": 350
      },
      "buildTime": 150,
      "popCap": 0,
      "age": "classical",
      "trains": ["gatherer", "dwarf", "berserk"],
      "dropsiteFor": ["hunt", "herd", "berries", "farm", "wood", "gold"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Placed off a Settlement (TownCenter nonsocketplaceprotoid). No population. trainingrate 0.75 (workers train 25% slower; not modelled). Also researches Masons, Architects, Rigsthula and the age-ups (listed only at the Town Center: single 'at'). Shares the Town Center build limit."
      }
    },
    {
      "id": "house",
      "name": {
        "pt-BR": "Casa",
        "en": "House"
      },
      "icon": "buildings/norse-house",
      "pantheon": "norse",
      "cost": {
        "wood": 45
      },
      "buildTime": 15,
      "popCap": 10,
      "limit": 16,
      "age": "archaic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ArchaicAgeNorse: 45 wood (Assign). 10 population; shared limit 16 (AbstractHouseBuildLimit). Built by Gatherers, Dwarves or infantry."
      }
    },
    {
      "id": "temple",
      "name": {
        "pt-BR": "Templo",
        "en": "Temple"
      },
      "icon": "buildings/norse-temple",
      "pantheon": "norse",
      "cost": {
        "wood": 135,
        "gold": 150
      },
      "buildTime": 30,
      "age": "archaic",
      "trains": [
        "hersir",
        "valkyrie",
        "einheri",
        "troll",
        "battle-boar",
        "frost-giant",
        "mountain-giant",
        "fire-giant",
        "fenris-wolf-brood"
      ],
      "researches": [
        "eyes-in-the-forest",
        "cave-troll",
        "hall-of-thanes",
        "disablot",
        "gjallarhorn",
        "safeguard",
        "thurisaz-rune",
        "jotuns",
        "rime",
        "omniscience",
        "granite-blood",
        "rampage"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ArchaicAgeNorse: 135 wood (Assign) and BuildPoints 30 (Override; proto 40)."
      }
    },
    {
      "id": "longhouse",
      "name": {
        "pt-BR": "Casa comunal",
        "en": "Longhouse"
      },
      "icon": "buildings/norse-longhouse",
      "pantheon": "norse",
      "cost": {
        "wood": 90
      },
      "buildTime": 25,
      "age": "classical",
      "trains": ["berserk", "throwing-axeman", "hirdman"],
      "researches": [
        "medium-infantry",
        "heavy-infantry",
        "champion-infantry",
        "levy-longhouse-soldiers",
        "conscript-longhouse-soldiers",
        "hamask",
        "call-of-valhalla",
        "swine-array",
        "huntress-axe",
        "berserkergang"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled by ClassicalAgeNorse. Built by Norse infantry/heroes."
      },
      "plural": {
        "pt-BR": "Casas comunais"
      }
    },
    {
      "id": "great-hall",
      "name": {
        "pt-BR": "Grande Salão",
        "en": "Great Hall"
      },
      "icon": "buildings/norse-great-hall",
      "pantheon": "norse",
      "cost": {
        "wood": 135
      },
      "buildTime": 40,
      "age": "classical",
      "trains": ["hersir", "raiding-cavalry", "jarl", "godi"],
      "researches": [
        "medium-cavalry",
        "heavy-cavalry",
        "champion-cavalry",
        "levy-great-hall-soldiers",
        "conscript-great-hall-soldiers",
        "sessrumnir",
        "thundering-hooves",
        "ring-giver",
        "vikings",
        "sons-of-sleipnir"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled by ClassicalAgeNorse. Also researches Hammer of Thunder (Thor) and Hall of Thanes (Forseti), which are listed at the Dwarven Armory and the Temple (single 'at'). No research-rate bonus in the files."
      },
      "plural": {
        "pt-BR": "Grandes Salões"
      }
    },
    {
      "id": "hill-fort",
      "name": {
        "pt-BR": "Forte de Colina",
        "en": "Hill Fort"
      },
      "icon": "buildings/norse-hill-fort",
      "pantheon": "norse",
      "cost": {
        "wood": 270,
        "gold": 300,
        "favor": 5
      },
      "buildTime": 135,
      "limit": 15,
      "age": "heroic",
      "trains": ["huskarl", "portable-ram", "ballista"],
      "researches": [
        "levy-hill-fort-soldiers",
        "conscript-hill-fort-soldiers",
        "draft-horses",
        "engineers",
        "advanced-fortifications",
        "dwarven-auger",
        "bravery"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "AbstractFortress (Mythic Age prerequisite), enabled by HeroicAgeNorse. Build limit 15. Also researches Medium/Heavy/Champion Infantry (listed at the Longhouse)."
      }
    },
    {
      "id": "armory",
      "name": {
        "pt-BR": "Armaria",
        "en": "Armory"
      },
      "icon": "buildings/norse-armory",
      "pantheon": "norse",
      "cost": {
        "wood": 135
      },
      "buildTime": 40,
      "age": "classical",
      "researches": [
        "copper-weapons",
        "copper-armor",
        "copper-shields",
        "bronze-weapons",
        "bronze-armor",
        "bronze-shields",
        "iron-weapons",
        "iron-armor",
        "iron-shields",
        "ballistics",
        "burning-pitch",
        "dwarven-breastplate"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ArchaicAgeNorse: 135 wood. Enabled only by ClassicalAgeOdin and ClassicalAgeLoki: Thor has no Armory (requires cannot express 'Odin or Loki')."
      },
      "excludeGods": ["thor"],
      "fieldMeta": {
        "excludeGods": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor (Dwarven Armory replaces the Armory))",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "dwarven-armory",
      "name": {
        "pt-BR": "Armaria de Anões",
        "en": "Dwarven Armory"
      },
      "icon": "buildings/norse-dwarven-armory",
      "pantheon": "norse",
      "cost": {
        "wood": 135
      },
      "buildTime": 40,
      "age": "archaic",
      "requires": ["thor"],
      "researches": [
        "copper-weapons-thor",
        "copper-armor-thor",
        "copper-shields-thor",
        "bronze-weapons-thor",
        "bronze-armor-thor",
        "bronze-shields-thor",
        "iron-weapons-thor",
        "iron-armor-thor",
        "iron-shields-thor",
        "ballistics-thor",
        "burning-pitch-thor",
        "dwarven-weapons",
        "meteoric-iron-armor",
        "dragonscale-shields",
        "hammer-of-thunder",
        "dwarven-breastplate-thor"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor only (ArchaicAgeThor Enable). Research rate 0.33 in Archaic, +0.67 Classical (1.0), +0.5 Heroic (1.5), +0.5 Mythic (2.0) (ResearchRate Absolute); research times here are at rate 1.0 (age scaling not modelled). Each ArmoryTechnology researched fires ThorDwarfSpawn: 1 free Dwarf at the Dwarven Armory (not modelled)."
      }
    },
    {
      "id": "market",
      "name": {
        "pt-BR": "Mercado",
        "en": "Market"
      },
      "icon": "buildings/norse-market",
      "pantheon": "norse",
      "cost": {
        "wood": 135
      },
      "buildTime": 40,
      "age": "classical",
      "trains": ["ox-caravan"],
      "researches": ["tax-collectors", "ambassadors", "coinage"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ArchaicAgeNorse: 135 wood. Enabled by ClassicalAgeNorse. One of the Heroic Age prerequisites."
      }
    },
    {
      "id": "dock",
      "name": {
        "pt-BR": "Doca",
        "en": "Dock"
      },
      "icon": "buildings/norse-dock",
      "pantheon": "norse",
      "cost": {
        "wood": 90
      },
      "buildTime": 25,
      "age": "archaic",
      "trains": [
        "fishing-ship",
        "transport-ship",
        "longboat",
        "dreki",
        "dragon-ship",
        "kraken",
        "jormun-elver"
      ],
      "researches": [
        "purse-seine",
        "salt-amphora",
        "enclosed-deck",
        "heroic-fleet",
        "heavy-warships",
        "champion-warships",
        "conscript-sailors",
        "long-serpent",
        "wrath-of-the-deep",
        "arctic-winds"
      ],
      "dropsiteFor": ["fish"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ArchaicAgeNorse: 90 wood (Assign) and BuildPoints 25 (Override; proto 30). Food dropsite."
      }
    },
    {
      "id": "sentry-tower",
      "name": {
        "pt-BR": "Torre de Sentinela",
        "en": "Sentry Tower"
      },
      "icon": "buildings/norse-sentry-tower",
      "pantheon": "norse",
      "cost": {
        "wood": 135,
        "gold": 100
      },
      "buildTime": 60,
      "limit": 30,
      "age": "classical",
      "researches": [
        "watch-tower",
        "signal-fires",
        "crenellations",
        "carrier-pigeons",
        "boiling-oil"
      ],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ArchaicAgeNorse: 135 wood. Enabled by ClassicalAgeNorse. Build limit 30. The 4 starting towers are placed by the random map scripts."
      }
    },
    {
      "id": "wooden-wall",
      "name": {
        "pt-BR": "Muralha de Madeira",
        "en": "Wooden Wall"
      },
      "icon": "buildings/norse-wooden-wall",
      "pantheon": "norse",
      "cost": {
        "gold": 3
      },
      "buildTime": 5,
      "age": "archaic",
      "researches": ["stone-wall"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "WallConnector piece: 3 gold, 5 s. WallShort 6 gold / 15 s, WallMedium 9 gold / 15 s, WallLong 15 gold / 15 s, WallGate 15 gold / 15 s."
      }
    },
    {
      "id": "farm",
      "name": {
        "pt-BR": "Fazenda",
        "en": "Farm"
      },
      "icon": "buildings/norse-farm",
      "pantheon": "norse",
      "tags": ["farm"],
      "cost": {
        "wood": 75
      },
      "buildTime": 10,
      "age": "classical",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Enabled by ClassicalAgeNorse. Built by Gatherers/Dwarves only (not in the infantry build list). Infinite food, 1 gatherer."
      }
    },
    {
      "id": "ox-cart",
      "name": {
        "pt-BR": "Carroça de Boi",
        "en": "Ox Cart"
      },
      "icon": "buildings/norse-ox-cart",
      "pantheon": "norse",
      "tags": ["dropsite", "mobile"],
      "cost": {
        "food": 40,
        "wood": 40
      },
      "buildTime": 15,
      "age": "archaic",
      "researches": [
        "husbandry",
        "hand-axe",
        "pickaxe",
        "plow",
        "survival-equipment",
        "irrigation",
        "bow-saw",
        "shaft-mine",
        "winter-harvest",
        "flood-control",
        "carpenters",
        "quarry"
      ],
      "dropsiteFor": ["hunt", "herd", "berries", "farm", "wood", "gold"],
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "OxCartBuilding foundation (40 food + 40 wood, 15 s) built by Gatherers/Dwarves only; it becomes the OxCart unit (0 pop, mobile dropsite for food, wood and gold). Researches the economic technologies. Loki: cost x0.5. One Ox Cart is a start unit."
      }
    },
    {
      "id": "wonder",
      "name": {
        "pt-BR": "Maravilha",
        "en": "Wonder"
      },
      "icon": "buildings/norse-wonder",
      "pantheon": "norse",
      "cost": {
        "food": 5000,
        "wood": 4500,
        "gold": 5000
      },
      "buildTime": 5400,
      "limit": 1,
      "age": "mythic",
      "meta": {
        "source": "Game files 19.17020 (proto.xml, techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "ArchaicAgeNorse: 4500 wood (Assign); 5000 food and 5000 gold. Enabled by MythicAgeNorse. AutoGather Favor 1.0/s = 60/min while it stands (proto.xml)."
      },
      "trickle": {
        "favor": 60
      }
    }
  ],
  "researches": [
    {
      "id": "husbandry",
      "name": {
        "pt-BR": "Pecuária",
        "en": "Husbandry"
      },
      "icon": "techs/norse-husbandry",
      "pantheon": "norse",
      "cost": {
        "wood": 100,
        "gold": 50
      },
      "time": 30,
      "at": "ox-cart",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["herd"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also +15 food carry capacity and +25% livestock fattening."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "hand-axe",
      "name": {
        "pt-BR": "Machado de Mão",
        "en": "Hand Axe"
      },
      "icon": "techs/norse-hand-axe",
      "pantheon": "norse",
      "cost": {
        "food": 120,
        "gold": 50
      },
      "time": 30,
      "at": "ox-cart",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["wood"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also +5 wood carry capacity."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "pickaxe",
      "name": {
        "pt-BR": "Picareta",
        "en": "Pickaxe"
      },
      "icon": "techs/norse-pickaxe",
      "pantheon": "norse",
      "cost": {
        "food": 50,
        "wood": 120
      },
      "time": 30,
      "at": "ox-cart",
      "age": "archaic",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["gold"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also +5 gold carry capacity."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "plow",
      "name": {
        "pt-BR": "Arado",
        "en": "Plow"
      },
      "icon": "techs/norse-plow",
      "pantheon": "norse",
      "cost": {
        "wood": 50,
        "gold": 100
      },
      "time": 40,
      "at": "ox-cart",
      "age": "classical",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "survival-equipment",
      "name": {
        "pt-BR": "Equipamento de sobrevivência",
        "en": "Survival Equipment"
      },
      "icon": "techs/norse-survival-equipment",
      "pantheon": "norse",
      "cost": {
        "wood": 100,
        "gold": 100
      },
      "time": 20,
      "at": "ox-cart",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "HuntingEquipment. Gatherers/Dwarves +25% HP, +10% hand attack, +50% ranged attack (BasePercent). No gather-rate effect."
      }
    },
    {
      "id": "irrigation",
      "name": {
        "pt-BR": "Irrigação",
        "en": "Irrigation"
      },
      "icon": "techs/norse-irrigation",
      "pantheon": "norse",
      "cost": {
        "wood": 150,
        "gold": 250
      },
      "time": 30,
      "at": "ox-cart",
      "age": "heroic",
      "requires": ["plow"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "bow-saw",
      "name": {
        "pt-BR": "Arco de Serra",
        "en": "Bow Saw"
      },
      "icon": "techs/norse-bow-saw",
      "pantheon": "norse",
      "cost": {
        "food": 250,
        "gold": 150
      },
      "time": 45,
      "at": "ox-cart",
      "age": "heroic",
      "requires": ["hand-axe"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["wood"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also +5 wood carry capacity."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "shaft-mine",
      "name": {
        "pt-BR": "Poços de Mina",
        "en": "Shaft Mine"
      },
      "icon": "techs/norse-shaft-mine",
      "pantheon": "norse",
      "cost": {
        "food": 150,
        "wood": 250
      },
      "time": 40,
      "at": "ox-cart",
      "age": "heroic",
      "requires": ["pickaxe"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.15,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["gold"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also +5 gold carry capacity."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "flood-control",
      "name": {
        "pt-BR": "Controle de Enchentes",
        "en": "Flood Control"
      },
      "icon": "techs/norse-flood-control",
      "pantheon": "norse",
      "cost": {
        "wood": 250,
        "gold": 350
      },
      "time": 40,
      "at": "ox-cart",
      "age": "mythic",
      "requires": ["irrigation"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["farm"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "carpenters",
      "name": {
        "pt-BR": "Carpinteiros",
        "en": "Carpenters"
      },
      "icon": "techs/norse-carpenters",
      "pantheon": "norse",
      "cost": {
        "food": 300,
        "gold": 200
      },
      "time": 55,
      "at": "ox-cart",
      "age": "mythic",
      "requires": ["bow-saw"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["wood"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also +5 wood carry capacity."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "quarry",
      "name": {
        "pt-BR": "Pedreira",
        "en": "Quarry"
      },
      "icon": "techs/norse-quarry",
      "pantheon": "norse",
      "cost": {
        "food": 200,
        "wood": 300
      },
      "time": 50,
      "at": "ox-cart",
      "age": "mythic",
      "requires": ["shaft-mine"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["gold"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also +5 gold carry capacity."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "masons",
      "name": {
        "pt-BR": "Pedreiros",
        "en": "Masons"
      },
      "icon": "techs/norse-masons",
      "pantheon": "norse",
      "cost": {
        "food": 200,
        "wood": 300
      },
      "time": 20,
      "at": "town-center",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Buildings +20% HP."
      }
    },
    {
      "id": "architects",
      "name": {
        "pt-BR": "Arquitetos",
        "en": "Architects"
      },
      "icon": "techs/norse-architects",
      "pantheon": "norse",
      "cost": {
        "food": 400,
        "wood": 500
      },
      "time": 30,
      "at": "town-center",
      "age": "heroic",
      "requires": ["masons"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Buildings +30% HP."
      }
    },
    {
      "id": "fortified-town-center",
      "name": {
        "pt-BR": "Centro Urbano Fortificado",
        "en": "Fortified Town Center"
      },
      "icon": "techs/norse-fortified-town-center",
      "pantheon": "norse",
      "cost": {
        "wood": 400,
        "gold": 400
      },
      "time": 60,
      "at": "town-center",
      "age": "heroic",
      "effects": [
        {
          "target": "popCap",
          "op": "add",
          "value": 10,
          "scope": {
            "ids": ["town-center"]
          },
          "note": "+10 pop per Town Center (15 -> 25)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Town Center +25% HP, +2 range, +50% attack, +10 population."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "purse-seine",
      "name": {
        "pt-BR": "Rede de Cerco",
        "en": "Purse Seine"
      },
      "icon": "techs/norse-purse-seine",
      "pantheon": "norse",
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 20,
      "at": "dock",
      "age": "classical",
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "ids": ["fishing-ship"],
            "sources": ["fish"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "salt-amphora",
      "name": {
        "pt-BR": "Ânfora com Sal",
        "en": "Salt Amphora"
      },
      "icon": "techs/norse-salt-amphora",
      "pantheon": "norse",
      "cost": {
        "wood": 200,
        "gold": 300
      },
      "time": 30,
      "at": "dock",
      "age": "heroic",
      "requires": ["purse-seine"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "ids": ["fishing-ship"],
            "sources": ["fish"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also +25 carry capacity."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "enclosed-deck",
      "name": {
        "pt-BR": "Convés Fechado",
        "en": "Enclosed Deck"
      },
      "icon": "techs/norse-enclosed-deck",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "wood": 200
      },
      "time": 40,
      "at": "dock",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heroic-fleet",
      "name": {
        "pt-BR": "Frota Heroica",
        "en": "Heroic Fleet"
      },
      "icon": "techs/norse-heroic-fleet",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 100,
        "gold": 100,
        "favor": 10
      },
      "time": 20,
      "at": "dock",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heavy-warships",
      "name": {
        "pt-BR": "Navios de Guerra Pesados",
        "en": "Heavy Warships"
      },
      "icon": "techs/norse-heavy-warships",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 20,
      "at": "dock",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "champion-warships",
      "name": {
        "pt-BR": "Navios de Guerra Campeões",
        "en": "Champion Warships"
      },
      "icon": "techs/norse-champion-warships",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 250,
        "gold": 200
      },
      "time": 20,
      "at": "dock",
      "age": "mythic",
      "requires": ["heavy-warships"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "conscript-sailors",
      "name": {
        "pt-BR": "Recrutar Marinheiros",
        "en": "Conscript Sailors"
      },
      "icon": "techs/norse-conscript-sailors",
      "pantheon": "norse",
      "cost": {
        "wood": 300
      },
      "time": 30,
      "at": "dock",
      "age": "mythic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "tags": ["ship"]
          },
          "note": "TrainPoints x0.80 Percent on every Ship."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "tax-collectors",
      "name": {
        "pt-BR": "Coletores de Impostos",
        "en": "Tax Collectors"
      },
      "icon": "techs/norse-tax-collectors",
      "pantheon": "norse",
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 35,
      "at": "market",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "TributePenalty -0.10, market buy factor -0.075 and sell factor +0.075 (Absolute)."
      }
    },
    {
      "id": "ambassadors",
      "name": {
        "pt-BR": "Embaixadores",
        "en": "Ambassadors"
      },
      "icon": "techs/norse-ambassadors",
      "pantheon": "norse",
      "cost": {
        "gold": 250
      },
      "time": 30,
      "at": "market",
      "age": "mythic",
      "requires": ["tax-collectors"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "TributePenalty set to 0; market buy factor -0.075 and sell factor +0.075 more."
      }
    },
    {
      "id": "coinage",
      "name": {
        "pt-BR": "Cunhagem",
        "en": "Coinage"
      },
      "icon": "techs/norse-coinage",
      "pantheon": "norse",
      "cost": {
        "gold": 200
      },
      "time": 40,
      "at": "market",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "TradeUnit speed x1.20 (BasePercent)."
      }
    },
    {
      "id": "medium-infantry",
      "name": {
        "pt-BR": "Infantaria Média",
        "en": "Medium Infantry"
      },
      "icon": "techs/norse-medium-infantry",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 150,
        "gold": 150
      },
      "time": 20,
      "at": "longhouse",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also researchable at the Hill Fort (single 'at' field: Longhouse used)."
      }
    },
    {
      "id": "heavy-infantry",
      "name": {
        "pt-BR": "Infantaria Pesada",
        "en": "Heavy Infantry"
      },
      "icon": "techs/norse-heavy-infantry",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 300
      },
      "time": 30,
      "at": "longhouse",
      "age": "heroic",
      "requires": ["medium-infantry"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also researchable at the Hill Fort."
      }
    },
    {
      "id": "champion-infantry",
      "name": {
        "pt-BR": "Infantaria Campeã",
        "en": "Champion Infantry"
      },
      "icon": "techs/norse-champion-infantry",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 500,
        "gold": 400
      },
      "time": 40,
      "at": "longhouse",
      "age": "mythic",
      "requires": ["heavy-infantry"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Also researchable at the Hill Fort."
      }
    },
    {
      "id": "levy-longhouse-soldiers",
      "name": {
        "pt-BR": "Convocar Soldados da Casa Comunal",
        "en": "Levy Longhouse Soldiers"
      },
      "icon": "techs/norse-levy-longhouse-soldiers",
      "pantheon": "norse",
      "cost": {
        "food": 150,
        "wood": 75
      },
      "time": 20,
      "at": "longhouse",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["berserk", "throwing-axeman", "hirdman"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "conscript-longhouse-soldiers",
      "name": {
        "pt-BR": "Recrutar Soldados da Casa Comunal",
        "en": "Conscript Longhouse Soldiers"
      },
      "icon": "techs/norse-conscript-longhouse-soldiers",
      "pantheon": "norse",
      "cost": {
        "food": 200,
        "wood": 100
      },
      "time": 30,
      "at": "longhouse",
      "age": "mythic",
      "requires": ["levy-longhouse-soldiers"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["berserk", "throwing-axeman", "hirdman"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "medium-cavalry",
      "name": {
        "pt-BR": "Cavalaria Média",
        "en": "Medium Cavalry"
      },
      "icon": "techs/norse-medium-cavalry",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 100
      },
      "time": 20,
      "at": "great-hall",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "heavy-cavalry",
      "name": {
        "pt-BR": "Cavalaria Pesada",
        "en": "Heavy Cavalry"
      },
      "icon": "techs/norse-heavy-cavalry",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 400,
        "gold": 200
      },
      "time": 30,
      "at": "great-hall",
      "age": "heroic",
      "requires": ["medium-cavalry"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "champion-cavalry",
      "name": {
        "pt-BR": "Cavalaria Campeã",
        "en": "Champion Cavalry"
      },
      "icon": "techs/norse-champion-cavalry",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 700,
        "gold": 200
      },
      "time": 40,
      "at": "great-hall",
      "age": "mythic",
      "requires": ["heavy-cavalry"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "levy-great-hall-soldiers",
      "name": {
        "pt-BR": "Convocar Soldados do Grande Salão",
        "en": "Levy Great Hall Soldiers"
      },
      "icon": "techs/norse-levy-great-hall-soldiers",
      "pantheon": "norse",
      "cost": {
        "food": 75,
        "wood": 75,
        "gold": 150
      },
      "time": 20,
      "at": "great-hall",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["hersir", "raiding-cavalry", "jarl", "godi"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "conscript-great-hall-soldiers",
      "name": {
        "pt-BR": "Recrutar Soldados do Grande Salão",
        "en": "Conscript Great Hall Soldiers"
      },
      "icon": "techs/norse-conscript-great-hall-soldiers",
      "pantheon": "norse",
      "cost": {
        "food": 100,
        "wood": 100,
        "gold": 200
      },
      "time": 30,
      "at": "great-hall",
      "age": "mythic",
      "requires": ["levy-great-hall-soldiers"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["hersir", "raiding-cavalry", "jarl", "godi"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "levy-hill-fort-soldiers",
      "name": {
        "pt-BR": "Convocar Soldados do Forte de Colina",
        "en": "Levy Hill Fort Soldiers"
      },
      "icon": "techs/norse-levy-hill-fort-soldiers",
      "pantheon": "norse",
      "cost": {
        "food": 75
      },
      "time": 20,
      "at": "hill-fort",
      "age": "heroic",
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["huskarl"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Huskarl TrainPoints x0.80 (Percent). Siege weapons not included."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "conscript-hill-fort-soldiers",
      "name": {
        "pt-BR": "Recrutar Soldados do Forte de Colina",
        "en": "Conscript Hill Fort Soldiers"
      },
      "icon": "techs/norse-conscript-hill-fort-soldiers",
      "pantheon": "norse",
      "cost": {
        "food": 100
      },
      "time": 30,
      "at": "hill-fort",
      "age": "mythic",
      "requires": ["levy-hill-fort-soldiers"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8,
          "scope": {
            "ids": ["huskarl"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Huskarl TrainPoints x0.80 (Percent). Prereqs: Levy Hill Fort Soldiers and the Mythic Age."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "draft-horses",
      "name": {
        "pt-BR": "Cavalos de Carga",
        "en": "Draft Horses"
      },
      "icon": "techs/norse-draft-horses",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 200
      },
      "time": 40,
      "at": "hill-fort",
      "age": "heroic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Siege weapons speed x1.20 (BasePercent)."
      }
    },
    {
      "id": "engineers",
      "name": {
        "pt-BR": "Engenheiros",
        "en": "Engineers"
      },
      "icon": "techs/norse-engineers",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 300,
        "gold": 500
      },
      "time": 40,
      "at": "hill-fort",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "advanced-fortifications",
      "name": {
        "pt-BR": "Fortificações Avançadas",
        "en": "Advanced Fortifications"
      },
      "icon": "techs/norse-advanced-fortifications",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 600,
        "gold": 600
      },
      "time": 30,
      "at": "hill-fort",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "omniscience",
      "name": {
        "pt-BR": "Onisciência",
        "en": "Omniscience"
      },
      "icon": "techs/norse-omniscience",
      "pantheon": "norse",
      "cost": {
        "gold": 100
      },
      "time": 4,
      "at": "temple",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "DynamicCost: 100 gold per enemy unit ('The cost is per enemy unit'); research 4 s. Shared LOS with all enemies."
      }
    },
    {
      "id": "copper-weapons",
      "name": {
        "pt-BR": "Armas de Cobre",
        "en": "Copper Weapons"
      },
      "icon": "techs/norse-copper-weapons",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 100,
        "gold": 100
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "copper-armor",
      "name": {
        "pt-BR": "Armadura de Cobre",
        "en": "Copper Armor"
      },
      "icon": "techs/norse-copper-armor",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 75,
        "gold": 75
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "copper-shields",
      "name": {
        "pt-BR": "Escudos de Cobre",
        "en": "Copper Shields"
      },
      "icon": "techs/norse-copper-shields",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 75,
        "gold": 75
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "bronze-weapons",
      "name": {
        "pt-BR": "Armas de Bronze",
        "en": "Bronze Weapons"
      },
      "icon": "techs/norse-bronze-weapons",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "requires": ["copper-weapons"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "bronze-armor",
      "name": {
        "pt-BR": "Armadura de Bronze",
        "en": "Bronze Armor"
      },
      "icon": "techs/norse-bronze-armor",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 150
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "requires": ["copper-armor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "bronze-shields",
      "name": {
        "pt-BR": "Escudos de Bronze",
        "en": "Bronze Shields"
      },
      "icon": "techs/norse-bronze-shields",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 200,
        "gold": 150
      },
      "time": 40,
      "at": "armory",
      "age": "heroic",
      "requires": ["copper-shields"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "iron-weapons",
      "name": {
        "pt-BR": "Armas de Ferro",
        "en": "Iron Weapons"
      },
      "icon": "techs/norse-iron-weapons",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 450,
        "gold": 450
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "requires": ["bronze-weapons"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "iron-armor",
      "name": {
        "pt-BR": "Armadura de Ferro",
        "en": "Iron Armor"
      },
      "icon": "techs/norse-iron-armor",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 400,
        "gold": 400
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "requires": ["bronze-armor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "iron-shields",
      "name": {
        "pt-BR": "Escudos de Ferro",
        "en": "Iron Shields"
      },
      "icon": "techs/norse-iron-shields",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 400,
        "gold": 350
      },
      "time": 50,
      "at": "armory",
      "age": "mythic",
      "requires": ["bronze-shields"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "ballistics",
      "name": {
        "pt-BR": "Balística",
        "en": "Ballistics"
      },
      "icon": "techs/norse-ballistics",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 50,
      "at": "armory",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "burning-pitch",
      "name": {
        "pt-BR": "Breu Incendiário",
        "en": "Burning Pitch"
      },
      "icon": "techs/norse-burning-pitch",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 500,
        "gold": 300
      },
      "time": 40,
      "at": "armory",
      "age": "mythic",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin/Loki version (Armory). Thor researches the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "copper-weapons-thor",
      "name": {
        "pt-BR": "Armas de Cobre",
        "en": "Copper Weapons"
      },
      "icon": "techs/norse-copper-weapons",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 100,
        "gold": 100
      },
      "time": 30,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "copper-armor-thor",
      "name": {
        "pt-BR": "Armadura de Cobre",
        "en": "Copper Armor"
      },
      "icon": "techs/norse-copper-armor",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 75,
        "gold": 75
      },
      "time": 30,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "copper-shields-thor",
      "name": {
        "pt-BR": "Escudos de Cobre",
        "en": "Copper Shields"
      },
      "icon": "techs/norse-copper-shields",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 75,
        "gold": 75
      },
      "time": 30,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "bronze-weapons-thor",
      "name": {
        "pt-BR": "Armas de Bronze",
        "en": "Bronze Weapons"
      },
      "icon": "techs/norse-bronze-weapons",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 40,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "copper-weapons-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "bronze-armor-thor",
      "name": {
        "pt-BR": "Armadura de Bronze",
        "en": "Bronze Armor"
      },
      "icon": "techs/norse-bronze-armor",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 150
      },
      "time": 40,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "copper-armor-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "bronze-shields-thor",
      "name": {
        "pt-BR": "Escudos de Bronze",
        "en": "Bronze Shields"
      },
      "icon": "techs/norse-bronze-shields",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 200,
        "gold": 150
      },
      "time": 40,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "copper-shields-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "iron-weapons-thor",
      "name": {
        "pt-BR": "Armas de Ferro",
        "en": "Iron Weapons"
      },
      "icon": "techs/norse-iron-weapons",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 450,
        "gold": 450
      },
      "time": 50,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "bronze-weapons-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "iron-armor-thor",
      "name": {
        "pt-BR": "Armadura de Ferro",
        "en": "Iron Armor"
      },
      "icon": "techs/norse-iron-armor",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 400,
        "gold": 400
      },
      "time": 50,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "bronze-armor-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "iron-shields-thor",
      "name": {
        "pt-BR": "Escudos de Ferro",
        "en": "Iron Shields"
      },
      "icon": "techs/norse-iron-shields",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 400,
        "gold": 350
      },
      "time": 50,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "bronze-shields-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "ballistics-thor",
      "name": {
        "pt-BR": "Balística",
        "en": "Ballistics"
      },
      "icon": "techs/norse-ballistics",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 150,
        "gold": 150
      },
      "time": 50,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "burning-pitch-thor",
      "name": {
        "pt-BR": "Breu Incendiário",
        "en": "Burning Pitch"
      },
      "icon": "techs/norse-burning-pitch",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 500,
        "gold": 300
      },
      "time": 40,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version at the Dwarven Armory (available in any age). Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "dwarven-weapons",
      "name": {
        "pt-BR": "Armas Enânicas",
        "en": "Dwarven Weapons"
      },
      "icon": "techs/norse-dwarven-weapons",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 500,
        "gold": 500
      },
      "time": 60,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "iron-weapons-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor only. Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "meteoric-iron-armor",
      "name": {
        "pt-BR": "Armadura de Ferro Meteórico",
        "en": "Meteoric Iron Armor"
      },
      "icon": "techs/norse-meteoric-iron-armor",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 500,
        "gold": 500
      },
      "time": 60,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "iron-armor-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor only. Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "dragonscale-shields",
      "name": {
        "pt-BR": "Escudos de Escamas de Dragão",
        "en": "Dragonscale Shields"
      },
      "icon": "techs/norse-dragonscale-shields",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 500,
        "gold": 500
      },
      "time": 60,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor", "iron-shields-thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor only. Thor's Dwarven Armory researches at x0.33 speed in Archaic, x1 Classical, x1.5 Heroic, x2 Mythic; the base (Classical) time is given. Each Dwarven Armory research spawns 1 free Dwarf (Thor bonus; not expressible as a modifier). Thor pays 10% less (modifier in thor.json)."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "hammer-of-thunder",
      "name": {
        "pt-BR": "Martelo do Trovão",
        "en": "Hammer of Thunder"
      },
      "icon": "techs/norse-hammer-of-thunder",
      "pantheon": "norse",
      "cost": {
        "gold": 125,
        "favor": 10
      },
      "time": 40,
      "at": "dwarven-armory",
      "age": "archaic",
      "requires": ["thor"],
      "effects": [
        {
          "target": "favorRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "ids": ["hersir"]
          },
          "note": "Hersir AutoGather Favor x1.5 BasePercent (0.6 -> 0.9/min); applies to the Hersir favor trickle."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor only (ArmoryTechnology). Hersir hand attack x1.15 and AutoGather Favor x1.5 (BasePercent). Also researchable at the Great Hall. At the Dwarven Armory the time scales with its research rate (121 s Archaic, 40 s Classical, 26.7 s Heroic, 20 s Mythic) and it spawns 1 free Dwarf. Thor pays 10% less (thor.json)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        },
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      },
      "spawn": {
        "dwarf": 1
      }
    },
    {
      "id": "watch-tower",
      "name": {
        "pt-BR": "Torre de Vigia",
        "en": "Watch Tower"
      },
      "icon": "techs/norse-watch-tower",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 250,
        "gold": 150
      },
      "time": 15,
      "at": "sentry-tower",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Lets Sentry Towers attack (renames them Watch Tower)."
      }
    },
    {
      "id": "signal-fires",
      "name": {
        "pt-BR": "Fogueiras Sinalizadoras",
        "en": "Signal Fires"
      },
      "icon": "techs/norse-signal-fires",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 150
      },
      "time": 30,
      "at": "sentry-tower",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "crenellations",
      "name": {
        "pt-BR": "Ameias",
        "en": "Crenellations"
      },
      "icon": "techs/norse-crenellations",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 150,
        "wood": 150
      },
      "time": 20,
      "at": "sentry-tower",
      "age": "classical",
      "requires": ["watch-tower"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "carrier-pigeons",
      "name": {
        "pt-BR": "Pombos Correio",
        "en": "Carrier Pigeons"
      },
      "icon": "techs/norse-carrier-pigeons",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 400
      },
      "time": 45,
      "at": "sentry-tower",
      "age": "heroic",
      "requires": ["signal-fires"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "boiling-oil",
      "name": {
        "pt-BR": "Óleo Fervente",
        "en": "Boiling Oil"
      },
      "icon": "techs/norse-boiling-oil",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 100,
        "wood": 300
      },
      "time": 40,
      "at": "sentry-tower",
      "age": "heroic",
      "requires": ["watch-tower"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "stone-wall",
      "name": {
        "pt-BR": "Muralha de Pedra",
        "en": "Stone Wall"
      },
      "icon": "techs/norse-stone-wall",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "food": 200,
        "gold": 200
      },
      "time": 40,
      "at": "wooden-wall",
      "age": "classical",
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high"
      }
    },
    {
      "id": "hamask",
      "name": {
        "pt-BR": "Hamask",
        "en": "Hamask"
      },
      "icon": "techs/norse-hamask",
      "pantheon": "norse",
      "tags": ["military"],
      "cost": {
        "wood": 175,
        "favor": 12
      },
      "time": 40,
      "at": "longhouse",
      "age": "classical",
      "requires": ["odin"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Odin only (ArchaicAgeOdin makes it obtainable; researched at the Longhouse, a Classical building). Berserk speed x1.10 and x1.5 bonus vs myth units."
      }
    },
    {
      "id": "eyes-in-the-forest",
      "name": {
        "pt-BR": "Olhos na Floresta",
        "en": "Eyes in the Forest"
      },
      "icon": "techs/norse-eyes-in-the-forest",
      "pantheon": "norse",
      "cost": {
        "gold": 75,
        "favor": 8
      },
      "time": 40,
      "at": "temple",
      "age": "archaic",
      "requires": ["loki"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Loki only. Nature objects grant vision; heroes +5% speed."
      }
    },
    {
      "id": "disablot",
      "name": {
        "pt-BR": "Dísablót",
        "en": "Disablot"
      },
      "icon": "techs/norse-disablot",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 200,
        "favor": 10
      },
      "time": 40,
      "at": "temple",
      "age": "classical",
      "requires": ["freyja"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Valkyrie -> Shieldmaiden Valkyrie."
      }
    },
    {
      "id": "thundering-hooves",
      "name": {
        "pt-BR": "Cascos Trovejantes",
        "en": "Thundering Hooves"
      },
      "icon": "techs/norse-thundering-hooves",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 150,
        "favor": 20
      },
      "time": 30,
      "at": "great-hall",
      "age": "classical",
      "requires": ["freyja"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Cavalry and Valkyrie +10% HP and speed."
      }
    },
    {
      "id": "sessrumnir",
      "name": {
        "pt-BR": "Sessrúmnir",
        "en": "Sessrumnir"
      },
      "icon": "techs/norse-sessrumnir",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 100,
        "wood": 100,
        "favor": 10
      },
      "time": 20,
      "at": "great-hall",
      "age": "classical",
      "requires": ["freyja"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Heroes +10% HP (BasePercent) and 'Enable Godi': the Godi can be trained in the Classical Age."
      }
    },
    {
      "id": "gjallarhorn",
      "name": {
        "pt-BR": "Gjallarhorn",
        "en": "Gjallarhorn"
      },
      "icon": "techs/norse-gjallarhorn",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 150,
        "favor": 10
      },
      "time": 30,
      "at": "temple",
      "age": "classical",
      "requires": ["heimdall"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Einheri -> Giant-killer Einheri."
      }
    },
    {
      "id": "safeguard",
      "name": {
        "pt-BR": "Salvaguarda",
        "en": "Safeguard"
      },
      "icon": "techs/norse-safeguard",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 100,
        "favor": 12
      },
      "time": 40,
      "at": "temple",
      "age": "classical",
      "requires": ["heimdall"],
      "effects": [
        {
          "target": "cost",
          "op": "pct",
          "value": -0.5,
          "scope": {
            "ids": [
              "town-center",
              "village-center",
              "temple",
              "hill-fort",
              "sentry-tower",
              "wooden-wall"
            ],
            "resources": ["gold"]
          },
          "note": "Gold cost x0.50 BasePercent on LogicalTypeBuildingNotWonderOrTitan (the Norse buildings with a gold cost, Wonder excluded)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Sentry Tower and walls +25% HP; gold cost x0.50 BasePercent on LogicalTypeBuildingNotWonderOrTitan (every Norse building except the Wonder and the Ox Cart)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Safeguard: cost Gold x0.50 BasePercent on every building except Wonder/Titan Gate (scope lists the main ones); tower/wall HP x1.25 not modelled."
        }
      }
    },
    {
      "id": "rigsthula",
      "name": {
        "pt-BR": "Rigsthula",
        "en": "Rigsthula"
      },
      "icon": "techs/norse-rigsthula",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 150,
        "favor": 18
      },
      "time": 20,
      "at": "town-center",
      "age": "classical",
      "requires": ["heimdall"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.8333,
          "note": "BuildingWorkRate x1.20 BasePercent = time / 1.2."
        },
        {
          "target": "researchTime",
          "op": "mul",
          "value": 0.8333,
          "except": [
            "husbandry",
            "hand-axe",
            "pickaxe",
            "plow",
            "survival-equipment",
            "irrigation",
            "bow-saw",
            "shaft-mine",
            "winter-harvest",
            "flood-control",
            "carpenters",
            "quarry"
          ],
          "note": "Includes age-up research. Not the Ox Cart (a unit, not a Building)."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "BuildingWorkRate x1.20 BasePercent on every Building: train and research (including age-ups) time x0.8333. The Ox Cart is a unit, not a Building, so its researches are not sped up."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Rigsthula: BuildingWorkRate x1.20 BasePercent on all buildings -> train/research time / 1.2 (x0.8333). Kept as mul on time."
        }
      }
    },
    {
      "id": "hall-of-thanes",
      "name": {
        "pt-BR": "Salão dos Thanes",
        "en": "Hall of Thanes"
      },
      "icon": "techs/norse-hall-of-thanes",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 150,
        "favor": 10
      },
      "time": 30,
      "at": "temple",
      "age": "classical",
      "requires": ["forseti"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Infantry and heroes +5% speed. Also researchable at the Great Hall."
      }
    },
    {
      "id": "dwarven-breastplate",
      "name": {
        "pt-BR": "Peitoral Enânico",
        "en": "Dwarven Breastplate"
      },
      "icon": "techs/norse-dwarven-breastplate",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 100,
        "favor": 10
      },
      "time": 30,
      "at": "armory",
      "age": "classical",
      "requires": ["forseti"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Berserk and Hirdman -15% hack vulnerability. Thor uses the '-thor' variant at the Dwarven Armory."
      }
    },
    {
      "id": "dwarven-breastplate-thor",
      "name": {
        "pt-BR": "Peitoral Enânico",
        "en": "Dwarven Breastplate"
      },
      "icon": "techs/norse-dwarven-breastplate",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 100,
        "favor": 10
      },
      "time": 30,
      "at": "dwarven-armory",
      "age": "classical",
      "requires": ["forseti", "thor"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Thor version (Dwarven Armory). Spawns 1 free Dwarf (Thor bonus); Thor pays 10% less."
      },
      "spawn": {
        "dwarf": 1
      },
      "fieldMeta": {
        "spawn": {
          "source": "Game files 19.17020 (techtree.xml ArchaicAgeThor SetOnTechResearchedTech ThorDwarfSpawn)",
          "checkedAt": "2026-10-29",
          "confidence": "high"
        }
      }
    },
    {
      "id": "cave-troll",
      "name": {
        "pt-BR": "Troll das Cavernas",
        "en": "Cave Troll"
      },
      "icon": "techs/norse-cave-troll",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 200,
        "favor": 10
      },
      "time": 40,
      "at": "temple",
      "age": "classical",
      "requires": ["forseti"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Troll -> Hamarrtroll."
      }
    },
    {
      "id": "arctic-winds",
      "name": {
        "pt-BR": "Ventos Árticos",
        "en": "Arctic Winds"
      },
      "icon": "techs/norse-arctic-winds",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 200,
        "favor": 10
      },
      "time": 40,
      "at": "dock",
      "age": "heroic",
      "requires": ["skadi"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Dreki attacks slow/freeze."
      }
    },
    {
      "id": "rime",
      "name": {
        "pt-BR": "Geada",
        "en": "Rime"
      },
      "icon": "techs/norse-rime",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 200,
        "favor": 20
      },
      "time": 40,
      "at": "temple",
      "age": "heroic",
      "requires": ["skadi"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Frost Giant -> Frost Giant of Thrym."
      }
    },
    {
      "id": "huntress-axe",
      "name": {
        "pt-BR": "Machado da Caçadora",
        "en": "Huntress' Axe"
      },
      "icon": "techs/norse-huntress-axe",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 150,
        "favor": 20
      },
      "time": 40,
      "at": "longhouse",
      "age": "heroic",
      "requires": ["skadi"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Throwing Axeman +1 range, homing projectiles."
      }
    },
    {
      "id": "winter-harvest",
      "name": {
        "pt-BR": "Colheita de Inverno",
        "en": "Winter Harvest"
      },
      "icon": "techs/norse-winter-harvest",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 100,
        "favor": 20
      },
      "time": 40,
      "at": "ox-cart",
      "age": "heroic",
      "requires": ["skadi"],
      "effects": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.2,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["farm"]
          }
        },
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.1,
          "scope": {
            "ids": ["gatherer", "dwarf"],
            "sources": ["hunt", "herd", "berries"]
          },
          "note": "Huntable, Herdable and WildCrops x1.10 BasePercent; Fishing Ships not included."
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Farms x1.20 and hunt, herd, berries x1.10 (BasePercent) on EconomicUpgraded (Gatherers and Dwarves; Fishing Ships are not EconomicUpgraded)."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "Game relativity BasePercent (+x% of the unmodified base value, summed with other BasePercent effects) -> op pct."
        }
      }
    },
    {
      "id": "wrath-of-the-deep",
      "name": {
        "pt-BR": "Fúria das Profundezas",
        "en": "Wrath of the Deep"
      },
      "icon": "techs/norse-wrath-of-the-deep",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 100,
        "favor": 15
      },
      "time": 40,
      "at": "dock",
      "age": "heroic",
      "requires": ["njord"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Kraken -> Trench Kraken."
      }
    },
    {
      "id": "ring-giver",
      "name": {
        "pt-BR": "Doador do Anel",
        "en": "Ring Giver"
      },
      "icon": "techs/norse-ring-giver",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 125,
        "favor": 25
      },
      "time": 30,
      "at": "great-hall",
      "age": "heroic",
      "requires": ["njord"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Jarl +15% HP and +1 bonus vs myth units."
      }
    },
    {
      "id": "vikings",
      "name": {
        "pt-BR": "Vikings",
        "en": "Vikings"
      },
      "icon": "techs/norse-vikings",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 175,
        "favor": 25
      },
      "time": 40,
      "at": "great-hall",
      "age": "heroic",
      "requires": ["njord"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Raiding Cavalry +1.5 divine hand damage and BountyResourceEarningReward Gold 10 per 80 damage to units (1 gold per 8 damage; not modelled)."
      }
    },
    {
      "id": "jotuns",
      "name": {
        "pt-BR": "Jotuns",
        "en": "Jotuns"
      },
      "icon": "techs/norse-jotuns",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 175,
        "favor": 30
      },
      "time": 40,
      "at": "temple",
      "age": "heroic",
      "requires": ["njord"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Mountain Giant -> Jotun."
      }
    },
    {
      "id": "long-serpent",
      "name": {
        "pt-BR": "Longa Serpente",
        "en": "Long Serpent"
      },
      "icon": "techs/norse-long-serpent",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 100,
        "gold": 200,
        "favor": 20
      },
      "time": 30,
      "at": "dock",
      "age": "heroic",
      "requires": ["bragi"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Longboat upgrade."
      }
    },
    {
      "id": "call-of-valhalla",
      "name": {
        "pt-BR": "Chamado de Valhalla",
        "en": "Call of Valhalla"
      },
      "icon": "techs/norse-call-of-valhalla",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 150,
        "favor": 20
      },
      "time": 40,
      "at": "longhouse",
      "age": "heroic",
      "requires": ["bragi"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Berserk +10% HP; ResourceReturn Favor 0.5 (Assign) on Berserks: favor when they die (not modelled)."
      }
    },
    {
      "id": "thurisaz-rune",
      "name": {
        "pt-BR": "Runa de Thurisaz",
        "en": "Thurisaz Rune"
      },
      "icon": "techs/norse-thurisaz-rune",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 100,
        "favor": 20
      },
      "time": 30,
      "at": "temple",
      "age": "heroic",
      "requires": ["bragi"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Myth units +10% speed and regenerate."
      }
    },
    {
      "id": "swine-array",
      "name": {
        "pt-BR": "Formação Svinfylking",
        "en": "Swine Array"
      },
      "icon": "techs/norse-swine-array",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 125,
        "favor": 15
      },
      "time": 50,
      "at": "longhouse",
      "age": "heroic",
      "requires": ["bragi"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Hirdman +10% attack, x2 vs cavalry."
      }
    },
    {
      "id": "sons-of-sleipnir",
      "name": {
        "pt-BR": "Filhos de Sleipnir",
        "en": "Sons of Sleipnir"
      },
      "icon": "techs/norse-sons-of-sleipnir",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 150,
        "favor": 20
      },
      "time": 40,
      "at": "great-hall",
      "age": "mythic",
      "requires": ["baldr"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Cavalry hand attack x1.20 and +1 bonus vs archers."
      }
    },
    {
      "id": "dwarven-auger",
      "name": {
        "pt-BR": "Verrumão dos Anões",
        "en": "Dwarven Auger"
      },
      "icon": "techs/norse-dwarven-auger",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 150,
        "favor": 15
      },
      "time": 40,
      "at": "hill-fort",
      "age": "mythic",
      "requires": ["baldr"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.75,
          "scope": {
            "ids": ["portable-ram"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Portable Ram TrainPoints x0.75 (Percent), plus speed and attack."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "berserkergang",
      "name": {
        "pt-BR": "Fúria Berserker",
        "en": "Berserkergang"
      },
      "icon": "techs/norse-berserkergang",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 150,
        "favor": 30
      },
      "time": 40,
      "at": "longhouse",
      "age": "mythic",
      "requires": ["tyr"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Berserks heal from 35% of damage dealt."
      }
    },
    {
      "id": "bravery",
      "name": {
        "pt-BR": "Bravura",
        "en": "Bravery"
      },
      "icon": "techs/norse-bravery",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "food": 250,
        "favor": 22
      },
      "time": 40,
      "at": "hill-fort",
      "age": "mythic",
      "requires": ["tyr"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Huskarl +20% attack, +1.25x vs buildings."
      }
    },
    {
      "id": "rampage",
      "name": {
        "pt-BR": "Rompante",
        "en": "Rampage"
      },
      "icon": "techs/norse-rampage",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "gold": 300,
        "favor": 20
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["hel"],
      "effects": [
        {
          "target": "trainTime",
          "op": "mul",
          "value": 0.05,
          "scope": {
            "tags": ["myth"]
          }
        }
      ],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Myth unit TrainPoints x0.05 (Percent): -95% training time."
      },
      "fieldMeta": {
        "effects": {
          "source": "Game files 19.17020 (techtree.xml)",
          "checkedAt": "2026-10-18",
          "confidence": "high",
          "note": "TrainPoints/BuildPoints/cost with relativity Percent (multiplicative) -> op mul; PopulationCapAddition Absolute -> add. Values confirmed."
        }
      }
    },
    {
      "id": "granite-blood",
      "name": {
        "pt-BR": "Sangue de Granito",
        "en": "Granite Blood"
      },
      "icon": "techs/norse-granite-blood",
      "pantheon": "norse",
      "tags": ["myth"],
      "cost": {
        "wood": 600,
        "favor": 30
      },
      "time": 40,
      "at": "temple",
      "age": "mythic",
      "requires": ["hel"],
      "effects": [],
      "meta": {
        "source": "Game files 19.17020 (techtree.xml)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "Fire Giant -> Son of Muspell; Giants more HP."
      }
    }
  ],
  "meta": {
    "source": "Game files 19.17020 (proto.xml, techtree.xml, major_gods.xml, god_powers/norse.godpowers, string tables)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Start (major_gods.xml): 3 Gatherers (Thor: 3 Dwarves), 1 Ox Cart, 1 Berserk, 200 food / 150 wood / 100 gold; the TC also auto-queues a Gatherer (startingqueue autotrain, not modelled). Ox Cart is modelled as a building (OxCartBuilding foundation built by workers). Gatherers/Dwarves only build Houses, Farms and Ox Carts; infantry and heroes build everything else except Farms and Ox Carts (the simulator does not restrict builders). Names are the official English and Brazilian Portuguese strings. Freyr (DLC) and his minor gods are excluded."
  }
}
